import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import MediaQuery from 'react-responsive';
import './Landing.css';

import { eventTypes, trackEvent } from '../../helpers/AnalyticsManager';
import SeeProjectsIcon from '../../images/home/see-projects-icon.png';
import bgVideoMp4 from '../../assets/home/video-home.mp4';
import BgVideoPoster from '../../assets/home/video-poster.png';

class LandingSection extends React.Component {
  constructor() {
    super();

    this.state = {
      words: ['INNOVATION', 'SOLUTIONS', 'VALUE DELIVERY'],
      currentWordIndex: 0,
      currentCharIndex: 8,
      shouldWait: true,
      deleting: false,
      tagline: 'INNOVATION',
      finalChar: '.',
    };

    this.taglineWaitTime = 1500;
    this.taglineTypingTime = 100;

    this.animateTagline = this.animateTagline.bind(this);

    this.timeout = null;
  }

  componentDidMount() {
    if (document.readyState === 'complete') {
      this.animateTagline();
    } else {
      window.addEventListener('load', this.animateTagline);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.animateTagline);
    clearTimeout(this.timeout);
  }

  animateTagline() {
    const {
      words,
      finalChar,
    } = this.state;

    let {
      currentWordIndex,
      currentCharIndex,
      tagline,
      shouldWait,
      deleting,
    } = this.state;

    let currentWord = words[currentWordIndex];
    const finished = currentCharIndex >= (currentWord.length);

    // Word has finished typing
    if (finished && !shouldWait) {
      shouldWait = true;
    }
    // The current word has already finished and will wait for the viewing time
    if (shouldWait && !deleting) {
      if (finalChar !== '.') {
        this.setState({ finalChar: '.' });
        this.timeout = setTimeout(() => this.animateTagline(), this.taglineTypingTime);
        return;
      }

      deleting = true;
      currentCharIndex = 0;
      currentWordIndex = (currentWordIndex + 1) % words.length;
      currentWord = words[currentWordIndex];

      this.setState({
        currentWordIndex,
        currentCharIndex,
        tagline,
        shouldWait,
        deleting,
      });
      this.timeout = setTimeout(() => this.animateTagline(), this.taglineWaitTime);
      return;
    }

    // The current word has finished and waited for the viweing time
    // Is deleting previous word
    if (deleting) {
      if (finalChar === '.') {
        this.setState({ finalChar: '' });
        this.timeout = setTimeout(() => this.animateTagline(), this.taglineTypingTime);
        return;
      }

      // Finished deleting the word
      if (tagline.length <= 0) {
        deleting = false;
        shouldWait = false;
      } else {
        tagline = tagline.slice(0, -1);
      }
    } else {
      tagline += currentWord[currentCharIndex];
      currentCharIndex += 1;
    }

    this.setState({
      currentWordIndex,
      currentCharIndex,
      tagline,
      shouldWait,
      deleting,
    });
    this.timeout = setTimeout(() => this.animateTagline(), this.taglineTypingTime);
  }


  render() {
    const {
      tagline,
      finalChar,
    } = this.state;

    return (
      <header className="LandingSection">
        <h1>
          CUTTING-EDGE
          <br />
          TECHNOLOGY
          <br />
          AIMING
          <br />
          <strong>{tagline}</strong>
          {finalChar}
        </h1>
        <div id="SeeProjects">
          <AnchorLink
            className="SeeProjectsLink"
            href="#projects-showcase"
            onClick={() => {
              trackEvent(eventTypes.homeProjectsScroll);
              return true;
            }}
          >
            <p>PROJECTS</p>
            <img src={SeeProjectsIcon} alt="down pointing arrow" />
          </AnchorLink>
        </div>

        <MediaQuery query="(min-width: 425px)">
          <video
            loop
            muted
            autoPlay
            poster={BgVideoPoster}
            className="video-bg"
          >
            <source src={bgVideoMp4} type="video/mp4" />
          </video>
        </MediaQuery>
      </header>
    );
  }
}

export default LandingSection;
